module.exports = __webpack_public_path__ + "static/media/icon6.62dcf316.png";